<template>
  <div name="max">
    <div class="w-95p mx-auto pb-10 grid md:grid-cols-2 grid-cols-1 space-x-6">
      <div>
        <a
          href="https://www.maxwhitlockgymnastics.co.uk/"
          target="_blank"
          class="hover:opacity-75"
        >
          <img class="opacity-75" src="/static/images/maxw.png" alt="" />
        </a>
      </div>

      <div>
        <h3 class="text-lg font-bold mb-2">
          Revolutionising gymnastics in Primary Education
        </h3>

        <p class="mb-2">
          Tailored CPD and rich resources for unleashing every child's
          potential.
        </p>
        <p>
          Max Whitlock Gymnastics seeks to revolutionise gymnastics in schools
          by providing as many children as possible with the opportunity to
          engage in this wonderful sport. <br />The aim is to equip children
          with valuable life lessons, laying the foundations for promising and
          bright futures, to nurture not only physical development but also
          in-still qualities that will help the children flourish in all aspects
          of life.
        </p>

        <div class="my-5" v-if="!hasMaxWhitlockAccess">
          <p class="font-semibold">
            Register your interest below to be notified of feature releases and
            be entered into our special Max Whitlock Olympic giveaway featuring
            PE goodies and free access to Max Whitlock Gymnastics PE Passport.
          </p>

          <div class="flex justify-between text-center w-7/12  mt-6" v-if="!registerComplete">
            <button
              @click="registerInterest()"
              class="block bg-blue-500 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Register my interest
            </button>

            <button
              @click="registerSignUp()"
              class="block bg-orange-500 bg-opacity-75 hover:bg-opacity-50 focus:bg-action-blue focus:bg-opacity-50 text-white font-semibold rounded py-3 px-4"
            >
              Sign school up now!
            </button>
          </div>

          <p class="text-green-500 font-bold mt-2" v-else>
            Thank you for registering your interest. <br />One of our team will
            be in touch and good luck in our Max Whitlock Olympic givaway
          </p>
        </div>
        <div class="ml-6" v-else>
          <iframe
            class="sproutvideo-player mt-4 w-1/2"
            src="https://videos.sproutvideo.com/embed/1191d2b61819e5ce98/ff9b49aa5a549c46?autoPlay=true&amp;playerTheme=dark&amp;playerColor="
            height="160"
            frameborder="0"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            title="Video Player"
          ></iframe>
        </div>
      </div>
    </div>

    <ModalSlide
        :show="showBoard"
        :headCss="'bg-opacity-25'"
        @closeModal="cancel()"
      >
      <template v-slot:header-icon>
        <i class="fas fa-bell"></i>
      </template>
        <template v-slot:header-title>
            <h2 class="text-xl font-bold">{{ typeTitle }}</h2>
        </template>
        <template v-slot:body>

            <p class="p-4" v-if="selectedType === 'signup'">Thank you for expressing an interest in signing up to Max Whitlock. <br/>
            Should you proceed, one of our team will be in touch and the Max Whitlock feature will be activated within your account in the next 24 hours. <br/>
            A corresponding invoice for £200 will be sent to your school admin contact.</p>

            <p class="p-4" v-else>Thank you for expressing an interest in signing up to Max Whitlock. <br/>
            Should you proceed, one of our team will be in touch to discuss details.</p>

            <div class="flex flex-wrap mx-3 mb-4">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Name
                </label>
                <input
                  v-model="contactName"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>
            <div class="flex flex-wrap mx-3 mb-8">
              <div class="w-full">
                <label class="form-label" for="grid-title">
                  Contact Email
                </label>
                <input
                  v-model="contactEmail"
                  class="p-2 mb-2 focus:border-red-200 focus:bg-white focus:outline-none"
                  id="grid-title"
                  type="text"
                  placeholder="Enter title"
                  required
                />
                <p class="text-red-300 text-xs italic">
                  Please fill out this field.
                </p>
              </div>
            </div>

            <div class="flex mx-auto w-8/12 p-2 space-x-4 pb-4">
                  <button
                    @click="processInterest()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-green-400 py-3"
                  >
                   Yes, please continue
                  </button>
                  <button
                    @click="cancel()"
                    class="publish-button hover:opacity-75 w-full cursor-pointer bg-red-400 py-2"
                  >
                    Cancel
                  </button>
                </div>
          
        </template>
      </ModalSlide>


  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";

const ModalSlide = () => import("@/components/ModalSlide.vue");

export default {
  name: "max",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    hasMaxWhitlockAccess() {
      return this.currentAccess.maxWhitlockAccess;
    },
    typeTitle() {
      return this.selectedType === 'login' ? "Signup to Max Whitlock" : "Register my interest"
    }
  },
  data() {
    return {
      registerComplete: false,
      showBoard: false,
      selectedType: null,
      contactName: "",
      contactEmail: "",
    };
  },
  created() {},
  mounted() {},
  methods: {
    completion() {
      this.registerComplete = true;
      this.selectedType = null 
      this.showBoard = false
    },
    registerInterest() {
      this.selectedType = "interest"
      this.showBoard = true
    },
    registerSignUp() {
      this.selectedType = "signup"
      this.showBoard = true
    },
    processInterest() {
      let result =  "Max Whitlock \nType: " + this.selectedType + "\nContact: " + this.contactName + "\nEmail: " + this.contactEmail
      let payload = { content: result };
      SchoolService.create("comms/feature-request", payload)
        .then((response) => this.completion())
        .catch((err) => {
          this.cancel();
          console.log("Reset error " + err);
        });
    },
    cancel() {
      this.selectedType = null 
      this.showBoard = false
    }
  },
  components: {
    ModalSlide
  },
};
</script>

<style scoped>
</style>